import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

import { LoginComponent } from './pages/login/login.component';
import { MapLinkComponent } from './pages/map-link/map-link.component';
import { DashboardLinkComponent } from './pages/dashboard-link/dashboard-link.component';
import { IpRestrictedComponent } from './pages/ip-restricted/ip-restricted.component';
import { ExternalLinkComponent } from './pages/external-link/external-link.component';
import { ChangeOrganizationComponent } from './change-organization/change-organization.component';
import { HorizonSsoComponent } from './pages/horizon-sso/horizon-sso.component';
import { ExternalLinkDownloadComponent } from './pages/external-link-download/external-link-download.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'setup-password',
    component: ResetPasswordComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'shared-map',
    component: MapLinkComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'shared-dashboard',
    component: DashboardLinkComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'ip-restricted',
    component: IpRestrictedComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'external-link',
    component: ExternalLinkComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'external-link-download',
    component: ExternalLinkDownloadComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'change-organization',
    component: ChangeOrganizationComponent,
    data: { routeConfig: { hideNavigation: true } }
  },
  {
    path: 'horizon-sso',
    component: HorizonSsoComponent,
    data: { routeConfig: { hideNavigation: true } }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule {}
